import { Injectable } from "@angular/core";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BaseBlotterDataAdapter } from "./BaseBlotterDataAdapter";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { BaseTableDefinitionFactory } from "../../model/BaseTableDefinitionFactory";

@Injectable()
export class RawDataOpsIntAdapter extends BaseBlotterDataAdapter {
  constructor(protected _tableDefinitionFactory: BaseTableDefinitionFactory) {
    super(_tableDefinitionFactory);
  }
}
